import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

/**
 * Compact, reusable KPI strip used to fill the empty space at the top of list
 * pages (Users, Assets, Allocation) with at-a-glance analytics. Self-contained
 * styling so it can drop into any page.
 *
 * @param {Array<{label:string,value:(string|number),icon?:object,color?:string,tint?:string}>} items
 */
export default function StatCards({items = []}) {
  if (!items.length) return null;
  return (
    <div style={styles.row}>
      {items.map((it) => (
        <div key={it.label} style={{...styles.card, borderLeft: `3px solid ${it.color || "#363166"}`}}>
          {it.icon && (
            <div style={{...styles.icon, background: it.tint || "#eef0fb", color: it.color || "#363166"}}>
              <FontAwesomeIcon icon={it.icon} />
            </div>
          )}
          <div>
            <div style={styles.value}>{it.value}</div>
            <div style={styles.label}>{it.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

const styles = {
  // Single-row summary bar: never wraps into a second row — on narrow
  // screens it scrolls horizontally instead of pushing the table down.
  row: {display: "flex", flexWrap: "nowrap", gap: 8, marginBottom: 8, overflowX: "auto", paddingBottom: 2},
  card: {
    flex: "1 1 0", minWidth: 104, background: "#fff", border: "1px solid #eef0f4",
    borderRadius: 9, padding: "5px 10px", boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
    display: "flex", alignItems: "center", gap: 8,
  },
  icon: {
    width: 26, height: 26, borderRadius: 7, flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.76rem",
  },
  value: {fontSize: "1.05rem", fontWeight: 800, color: "#1f2937", lineHeight: 1},
  label: {fontSize: "0.6rem", color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.04em", marginTop: 2, whiteSpace: "nowrap"},
};
